import { Component, HostListener } from "@angular/core";

@Component({
  selector: "vw-expand",
  templateUrl: "./expand.component.html",
})
export class ExpandComponent {
  isOpen = false;

  constructor() {}

  toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }

  @HostListener("document:keyup.escape", ["$event"]) onKeydownHandler(): void {
    this.close();
  }

  close(): void {
    this.isOpen = false;
  }
}
